export default "__VITE_ASSET__Curq7sk1__"